import Vue from "vue";
import VueRouter from "vue-router";
import HomeRouter from "../views/HomeRouter.vue";
import HomeCompleteSignInAs from '../views/home-complete-sign-in-as.vue';
import ShortLinkRouter from "../views/ShortLinkRouter.vue";
import Home from "../views/Home.vue";
import SignIn from "../views/sign-in.vue";
import SignInSSO from "../views/sign-in-sso.vue";
import ResetPassword from "../views/reset-password.vue"
import StartResetPassword from "../views/start-reset-password.vue"
import AllTests from "../views/test/all-tests.vue";
import TestMessengerLayout from "../views/test/test-messenger-layout.vue";
import TestAxios from '../views/test/test-axios.vue';
import TestRevokeAuth from '../views/test/test-revoke-auth.vue';
import TestInput from '../views/test/test-input.vue';
import TestGetRestAPIEnvironment from '../views/test/test-environment.vue';
import TestGlobalControls from '../views/test/test-global-controls.vue';
import TestTable from '../views/test/test-table.vue';
import TestSignature from '../views/test/test-signature.vue';

import SearchOAuthIntegrations from '../views/settings/organizations/settings-employee-search-oauth-integrations.vue';
import ShopifyInstall from "../views/integrations/shopify/shopify-install.vue"

import AllAdmin from '../views/admin/all-admin.vue';
import AdminOrganizationSetupWizard from '../views/admin/admin-organization-setup-wizard.vue';
import AdminSearchOrganizations from '../views/admin/admin-search-organizations.vue';
import AdminSearchEmployees from '../views/admin/admin-search-employees.vue';
import AdminReports from '../views/admin/admin-reports.vue';
import AdminStartReport from '../views/admin/admin-report-start.vue';
import AdminPasswordResetLinks from '../views/admin/ admin-password-reset-links.vue';
import AdminSeparateCustomersProspects from '../views/admin/admin-separate-customers-prospects.vue';
import AdminStockImages from '../views/admin/admin-stock-images.vue';

import ErrorNoEmployeeEndpoints from '../views/error/error-no-employee-endpoints.vue';
import ErrorConversationNotFound from '../views/error/error-conversation-not-found.vue';

import SettingsOrganization from '../views/settings/organizations/settings-organization.vue';
import SettingsOrganizationTestWidget from '../views/settings/organizations/settings-organization-test-widget.vue';
import SettingsOrganizationDataCleaning from '../views/settings/organizations/settings-organization-data-cleaning.vue';
import SettingsOrganizationSSOPage from '../views/settings/organizations/settings-organization-sso-page.vue';
import EditInbox from '../views/settings/organizations/inboxes/edit-inbox.vue';
import SettingsAccount from '../views/settings/account/settings-account.vue';
import AccountChangeLog from '../views/settings/organizations/account-change-log.vue';
import AccountAccessLog from '../views/settings/organizations/account-access-log.vue';

import AdminSearchRedChirpNumbers from '../views/admin/admin-search-redchirp-numbers.vue';

import ContactRequest from '../views/contact-requests/contact-request.vue';


import SearchOpenContactRequests from '../views/contact-requests/search-open-contact-requests.vue';
import FullTextContacts from '../views/contacts/search-contacts.vue';
import EditContact from '../views/contacts/create-contact-dialog.vue';

import TestAttachments from '../views/test/test-attachments.vue';

import ViewPayment from '../views/payments/view-payment.vue';
import SearchPayments from '../views/payments/search-payments.vue';
import MakePayment from '../views/payments/public/make-payment.vue';
import DemoTracking from '../views/payments/public/demo-tracking.vue';

import AdfSend from '../views/integrations/adf/adf-send.vue';
import AdfCopyNote from '../views/integrations/adf/adf-copy-note.vue';

import ios_to_instructions from "../views/ios/ios-to-instructions.vue";
import ios_launcher from "../views/ios/ios-launcher.vue";



import TestShowdown from '../views/test/test-showdown.vue';



import ViewBulkOptOutDetails from '../views/bulk/view-consent-detail.vue';
import ViewBulkMessage from '../views/bulk/view-bulk-message.vue';
import BulkRecipientImport from '../views/bulk/import-recipients.vue';
import BulkRecipientPreview from '../views/bulk/preview-recipients.vue';
import SearchBulkOptInOut from '../views/bulk/search-consent-register.vue';
import SearchBulkMessages from '../views/bulk/search-bulk-messages.vue';
import BulkRecipientRemoveRecentOrder from '../views/bulk/bulk-recipients-remove-recent-orders.vue';
import AdminBulkMessageTemplates from '../views/bulk/templates/bulk-message-template-admin.vue';

import SearchSavedMessages from '../views/saved-messages/search-saved-messages.vue';

import SearchInboxContactRequests from '../views/contact-requests/search-inbox-contact-requests.vue';
import ViewInboxContactRequestProfile from '../views/contact-requests/detail.vue'

import AdminUptime from '../views/admin/admin-uptime.vue';
import AdminMultiDemo from '../views/admin/admin-multidemo.vue';
import AdminProcessHistory from '../views/admin/admin-process-history.vue';

import FormConnect from '../views/contact-requests/form-connect.vue';
import WidgetAnalytics from '../views/admin/admin-widget-analytics.vue';

import PublicSandersonBarrettJackson from '../views/public/sanderson/barrett-jackson.vue';
import PublicWidgetCode from '../views/public/redchirp/widget-pixel-code-instructions.vue';
import PublicWidgetGTM from '../views/public/redchirp/widget-gtm-instructions.vue';
import PublicLegalCenter from '../views/public/legal/legal-home.vue';
import PulbicUpdatedAgreements2026Announcement from '../views/public/legal/updated-agreements-2026-announcement'
import PublicMagicLinkExpire from '../views/public/magic-link/magic-link-expire.vue';

import PublicPlatypusTour from '../views/public/platypus/your-tour.vue';
import PublicYourTasting from '../views/public/tasting/your-tasting.vue';


import InboxEmailLog from '../views/settings/organizations/inbox-email-log.vue';

import IntegrationCommerce7StartConversation from '../views/integrations/commerce7/commerce7-start-conversation.vue';


import EditWidgetSettings from '../views/settings/edit-widget-settings.vue';

import AdminProcessors from '../views/admin/admin-processors.vue';
import AdminKnobs from '../views/admin/admin-knobs.vue';
import AdminBuiltInRateCards from '../views/admin/admin-built-in-rate-cards.vue';
import OrganizationSettingsRateCard from '../views/settings/organizations/settings-organization-rate-card.vue';

import AdminIntuit from '@/views/admin/admin-intuit.vue';
import AdminBillingSearchOrganizations from '@/views/billing/admin-billing-search-organizations.vue';
import AdminBillingOneOrganizations from '@/views/billing/admin-billing-one-organization.vue';
import ComplianceAll from '@/views/compliance/all-compliance.vue';
import ComplianceExportCommunicationLog from '@/views/compliance/compliance-export-communication-log.vue';
import ComplianceArchives from '@/views/compliance/compliance-archives.vue';

import EmployeeFollowing from '@/views/settings/account/employee-following.vue';


import TeamNumberVoice from '@/views/settings/organizations/settings-team-number-voice.vue';

import EditBannerBranding from '@/views/settings/organizations/edit-banner-branding.vue';



import AutoMessageHome from '@/views/auto-messages/auto-message-home.vue';
import AutoMessageSettings from '@/views/auto-messages/auto-message-template-search.vue';
import AutoMessageTemplateSettings from '@/views/auto-messages/auto-message-template-settings.vue';

import AutoMessageSearchMessages from '@/views/auto-messages/auto-message-search-messages.vue';
import AutoMessageSearchAllMessages from '@/views/auto-messages/auto-message-search-all-messages.vue';


import AutoMessageManualTrigger from '@/views/auto-messages/auto-message-manual-trigger.vue';

import SettingOrganizationEndpointUnavailableAutoResponse from '@/views/settings/organizations/settings-organization-endpoint-unavailable-auto-response.vue';


import SettingsOrganizationKeywordAutoresponses from '@/views/settings/organizations/keyword_auto_responses/settings-organization-keyword-auto-responses.vue';
import EditKeywordAutoResponse from '@/views/settings/organizations/keyword_auto_responses/edit-keyword-auto-response.vue';
import ReportingKeywordAutoResponse from '@/views/settings/organizations/keyword_auto_responses/keyword-auto-response-reporting.vue';

import SettingsOrganizationCTIAKeywordAutoresponses from '@/views/settings/organizations/ctia_keyword_auto_responses/settings-organization-ctia-keyword-auto-responses.vue';

import EditInboxes from '@/views/settings/organizations/inboxes/edit-inboxes.vue';
import SettingsOrganizationWidget from '@/views/settings/organizations/settings-organization-widget.vue';

import AdminSearchIncidents from '@/views/incidents/search-incidents.vue';

import EditIncident from '@/views/incidents/edit-incident.vue';

import RedChirpMRR from '@/views/billing/admin-mrr.vue';

import SearchLists from '@/views/lists/search-lists.vue';
import EditList from '@/views/lists/edit-list.vue';

import AdminSetupDemo from '@/views/admin/admin-setup-demo.vue';

import SettingsOrganizationSpamNumbers from '@/views/settings/organizations/settings-organization-spam.vue';

import CRMContacts from '@/views/integrations/crm/crm-customers.vue';
import CRMOrders from '@/views/integrations/crm/crm-orders.vue';
import IntegrationCRMSearchConversations from '@/views/integrations/crm/integration-crm-search-conversations.vue';

import AdminSearchRestAPIReference from '@/views/admin/admin-search-rest-api-reference.vue';

import TestTockReservation from '@/views/test/test-tock.vue';

import AdminTypeform from '@/views/admin/admin-typeform.vue';

import AdminTypeformSettings from '@/views/admin/admin-typeform-settings.vue';

import SearchEndpointValidationDetails from '@/views/endpoint-validation/search-validation-details.vue';

import SettingsOrganizationIntroductions from '@/views/settings/organizations/introductions/settings-organization-introductions.vue';

import SettingsOrganizationBrandedLinkShortener from '@/views/settings/organizations/setting-organization-branded-link-shortener-settings.vue';


import CRMHome from '@/views/integrations/crm/crm-home.vue'

import CRMShipments from '@/views/integrations/crm/crm-shipments.vue';
import CRMReservations from '@/views/integrations/crm/crm-reservations.vue';
import CRMReservationTimeZones from '@/views/integrations/crm/crm-reservation-location-time-zones.vue';
import Events from '@/views/auto-messages/events.vue';
import ShippingEventsHeldInAbeyance from '@/views/auto-messages/shipping-events-held-in-abeyance.vue';
import CRMTagMetaData from '@/views/integrations/crm/crm-tag-meta-data.vue';
import CRMTagChangeLog from '@/views/integrations/crm/crm-tag-change-log.vue';
import CRMClubMetaData from '@/views/integrations/crm/crm-club-meta-data.vue';
import CRMGroupMetaData from '@/views/integrations/crm/crm-group-meta-data.vue';

import SettingsOrganizationTags from '@/views/settings/organizations/tags/settings-organization-tags.vue';
import SettingsOrganizationOrderAttribution from '@/views/settings/organizations/settings-organization-order-attribution.vue';
import SettingsOrganizationOrderAttributionOne from '@/views/settings/organizations/settings-organization-order-attribution-one.vue';

import SettingEditOneTag from '@/views/settings/organizations/tags/settings-organization-edit-tag.vue';

import RedChirpCRMViewOrganization from '@/components/rc_crm/rc-crm-view-organization.vue';

import WelcomeOrdinaryUser from '@/views/welcome/welcome.vue';

import AdminRedChirpStripeSearch from '@/views/admin/admin-redchirp-stripe-search.vue';

import OrganizationSettingsRedChirpBilling from '@/views/settings/organizations/settings-redchirp-billing.vue';
import CreateOrganization from '@/views/admin/admin-create-organization.vue';

import DefaultOptInForm from '@/views/public/opt-in/default-opt-in-form.vue';
import TollFreeOptInForm from '@/views/public/opt-in/toll-free-opt-in-form.vue';
import TermsAndConditionsAddendum from '@/views/public/opt-in/text-messaging-terms-and-conditions-addendum.vue';
import PrivacyPolicyAddendum from '@/views/public/opt-in/text-messaging-privacy-policy-addendum.vue';

import SearchForms from '@/views/settings/forms/search-forms.vue';
import SearchGuestCheckInForms from '@/views/guest-check-in/search-forms-guest-check-in.vue';
import GuestCheckInTemplateSelection from '@/views/guest-check-in/guest-check-in-template-selection.vue';
import GuestCheckInEdit from '@/views/guest-check-in/guest-check-in-edit.vue';
import GuestCheckInFormsDemoDefault from "@/views/public/opt-in/demo-guest-checkin/form-default.vue";
import GuestCheckInFormsDemoConservative from "@/views/public/opt-in/demo-guest-checkin/form-conservative.vue";
import GuestCheckInFormsDemoDiscount from "@/views/public/opt-in/demo-guest-checkin/form-discount.vue";
import GuestCheckInSubmissions from '@/views/guest-check-in/guest-check-in-submissions.vue';
import GuestCheckInAnalytics from '@/views/guest-check-in/guest-check-in-analytics.vue';
import SearchOrderConfirmationForms from '@/views/order-confirmation/search-forms-order-confirmation.vue';
import OrderConfirmationTemplateSelection from '@/views/order-confirmation/order-confirmation-template-selection.vue';
import OrderConfirmationEdit from '@/views/order-confirmation/order-confirmation-edit.vue';
import OrderConfirmationSubmissions from '@/views/order-confirmation/order-confirmation-submissions.vue';
import OrderConfirmationAnalytics from '@/views/order-confirmation/order-confirmation-analytics.vue';
import OrderConfirmationDemoStart from "@/views/public/opt-in/demo-order-confirmation-flow.vue";

import DemoSelector from "@/views/demos/demo-selector.vue";
import SearchGuestCheckInFormsDemoGateway from '@/views/demos/gateway-search-forms-guest-check-in-demo.vue';
import OrderConfirmationDemoGateway from "@/views/demos/gateway-order-confirmation-demo.vue";
import CRMAccountConfirmationDemoGateway from "@/views/demos/gateway-crm-account-confirmation-demo.vue";
import CRMAccountConfirmationDemoStart from "@/views/public/opt-in/demo-crm-account-confirmation-flow.vue";

import EditForm from '@/views/settings/forms/edit-form-page.vue';
import CustomFormFillPage from '@/views/public/opt-in/custom-form-fill-page.vue';

import AccountSettingsAlerts from '@/views/settings/account/settings-account-alerts.vue';
import AdminAlerts from '@/views/admin/admin-alerts.vue';

import AdminSearchInvoices from '@/views/billing/admin-billing-search-invoices.vue';

import PublicRedChirpProvidePaymentThankYou from '@/views/public/redchirp/public-red-chirp-provide-new-payment-method-thanks.vue';
import PublicRedChirpProvidePaymentStart from '@/views/public/redchirp/public-red-chirp-provide-new-payment-method-start.vue';
import PublicRedChirpProvideWineDirectCredentials from '@/views/public/redchirp/public-red-chirp-provide-winedirect-credentials.vue';
import PublicRedChirpProvideSecret from '@/views/public/redchirp/public-red-chirp-provide-secret.vue';

import PublicLinkTreeWineShipping from '@/views/public/link-tree/link-tree-wine-shipping.vue';
import AdminLinkTree from '@/views/admin/admin-link-trees.vue';

import Help from '@/views/help.vue';

import AdminSecrets from '@/views/admin/admin-secrets.vue';

import WelcomeAdminTCRCampaignRegistration from '@/views/welcome/welcome-admin-tcr-campaign-registration.vue';

import SettingsOrganizationSchedule from '@/views/settings/organizations/settings-organization-schedule.vue';

import AdminTCREvents from '@/views/admin/admin-tcr-events.vue';
import AdminTCRCampaigns from '@/views/admin/admin-tcr-campaigns.vue';

import SearchLinks from '@/views/settings/organizations/links/search-links.vue';

import AdminCalendar from '@/views/integrations/calendar/admin-calendar.vue';
import AdminCalendarEvents from '@/views/integrations/calendar/admin-calendar-events.vue';
import AdminCalendlyEventTypes from '@/views/integrations/calendar/admin-calendly-event-types.vue';
import MediaAssetPageEditAll from '@/views/media-assets/media-asset-page-edit-all.vue';

import EditOneMediaAsset from '@/views/media-assets/page-edit-one-media-asset.vue';

import BigCommercePairOrganization from '@/views/integrations/big-commerce/big-commerce-pair-organization.vue';
import BigCommercePairComplete from '@/views/integrations/big-commerce/big-commerce-pair-complete.vue';

import AdminMultiOrgEmployee from '@/views/admin/admin-multi-org-employee.vue';

import PublicConfirmDemoBooking from '@/views/payments/public/confirm-demo-booking.vue';

import SalesAfterDemoBookingSurveys from '@/views/admin/admin-after-demo-booking-surveys.vue';

import PortalOutshineryHome from '@/views/integrations/outshinery/portal-outshinery-home.vue';

import AdminEngagementHome from '@/views/admin/engagement/admin-engagement-home.vue';
import AdminEngagementBulkMessages from '@/views/admin/engagement/admin-engagement-bulk-messages.vue';
import AdminEngagementContactRequestAlarm from '@/views/admin/engagement/admin-engagement-contact-request-alarm.vue';

import AdminNRR from '@/views/billing/admin-nrr.vue';

import SearchBulkContactChanges from '@/views/contacts/search-bulk-contact-changes.vue';
import SearchBulkContactChangeEntries from '@/views/contacts/search-bulk-contact-change-entries.vue';

import PublicRestrictedMessagingTimes from '@/views/public/redchirp/public-restricted-messaging-times.vue';

import CRMOrdersByPhone from '@/views/integrations/crm/crm-orders-by-phone.vue';


import AllAnalytics from '@/components/analytics/all-analytics.vue';

import AnalyticsWebChat from '@/components/analytics/analytics-web-chat.vue';


import AnalyticsAllBulkMessages from '@/components/analytics/analytics-all-bulk-messages.vue';
import AnalyticsAllClubCustomization from '@/components/analytics/analytics-all-club-customization.vue';
import AnalyticsOneBulkMessageAnalyticsGroup from '@/components/analytics/analytics-one-bulk-message-analytics-group.vue';
import AnalyticsOptIn from '@/components/analytics/analytics-opt-in.vue';

import RedChirpStaffRoles from '@/views/admin/admin-red-chirp-staff-roles.vue';

import AdminTNTools from '@/views/admin/admin-tn-tools.vue';

import Provision from '@/views/provision/provision.vue';

import AdminSalesForecast from '@/views/billing/admin-sales-forecast.vue';

import SettingsOrganizationAPIKeys from '@/views/settings/organizations/settings-organization-api-keys.vue';

import BulkMessageTemplateCreatePage from '@/views/bulk/templates/bulk-message-template-create-page.vue';
import CustomConsentAgreements from '@/views/settings/consent-agreements/search-custom-consent-agreements.vue';
import SearchConsentImports from '@/views/consent/search-consent-imports.vue';
import ConsentImportUpload from '@/views/consent/consent-import-upload.vue';
import ContactImportPage from '@/views/contacts/contact-import-page.vue';
import SearchContactImports from '@/views/contacts/search-contact-imports.vue';
import ContactListImportUpload from '@/views/lists/contact-list-import-upload.vue';
import SearchContactListImports from '@/views/lists/search-contact-list-imports.vue';

import IntegrationSyncHistory from '@/views/integrations/sync-history.vue';
import IntegrationSyncHistoryOneBatch from '@/views/integrations/sync-history-one-batch.vue';
import DeveloperSearchMyApps from '@/views/app-store/developer-search-my-apps.vue';
import DeveloperEditApp from '@/views/app-store/developer-edit-app.vue';
import SearchBulkMessageRecipientImports from '@/views/bulk/search-bulk-message-recipients-imports.vue';
import BulkMessageRecipientsImportUpload from '@/views/bulk/bulk-message-recipients-import-upload.vue';

import DeveloperSearchMyAppInstalls from '@/views/app-store/developer-search-my-app-installs.vue'
import DeveloperAppCredentials from '@/views/app-store/developer-app-credentials.vue';
import AppSearch from '@/views/app-store/app-search.vue';
import AppDetails from '@/views/app-store/app-details.vue';
import TestTimeline from '@/views/test/test-timeline.vue';
import PublicConversationComment from '@/views/public/comment-request/public-conversation-comment-request.vue';
import BulkMessageSentimentForecast from '@/views/bulk/bulk-message-sentiment-forecast.vue';
import BulkMessageRecipientInferenceDetail from '@/views/model/model-r1-recipient-inference.vue';
import ModelR1Edit from '@/views/model/model-r1-edit.vue';
import SettingsOrganizationFonts from '@/views/settings/organizations/settings-organization-fonts.vue';

import LightboxSearchSettings from '@/views/lightbox/lightbox-settings-search.vue';
import LightboxTemplateSelection from '@/views/lightbox/lightbox-template-selection.vue';
import LightboxEdit from '@/views/lightbox/lightbox-edit.vue';
import LightboxURLS from '@/views/lightbox/lightbox-urls.vue';
import LightboxSubmissions from '@/views/lightbox/lightbox-submissions.vue';


import Accessibility from '@/views/accessibility/accessibility.vue';
import AdminShortenedLinkDomains from '@/views/admin/admin-shortened-link-domains.vue';

import VersionService from '@/js/HashVersion.js';

var RedChirp = require("../js/RedChirp.js");

Vue.use(VueRouter);

const routes = [
  {
    path: "/app/home",
    name: "home",
    component: HomeRouter,
  },
  {
    path: "/app/home-complete-sign-in-as/:employee_id",
    name: "home-complete-sign-in-as",
    component: HomeCompleteSignInAs,
  },
  {
    path: "/app/home/:endpoint",
    name: "home_with_endpoint",
    component: HomeRouter,
  },
  {
    path: "/app/welcome/:employee_id",
    name: "welcome_ordinary_user",
    component: WelcomeOrdinaryUser,
  },
  {
    path: "/app/provision/:organization_id",
    name: "provision",
    component: Provision,
  },
  {
    path: "/app/welcome/admin-tcr-campiang-registration/:organization_id",
    name: "welcome_admin_tcr_campaign_registration",
    component: WelcomeAdminTCRCampaignRegistration,
  },
  {
    path: "/app/lists/:organization_id",
    name: "search-lists",
    component: SearchLists,
  },
  {
    path: "/app/lists/edit/:list_id",
    name: "edit-list",
    component: EditList,
  },
  {
    path: "/app/compliance/:organization_id",
    name: "compliance-all",
    component: ComplianceAll,
  },
  {
    path: "/app/numbers/team/voice-settings/:organization_id/:endpoint",
    name: "team-number-voice-settings",
    component: TeamNumberVoice,
  },
  {
    path: "/app/auto-messages/:organization_id",
    name: "auto-messages-settings",
    component: AutoMessageSettings,
  },
  {
    path: "/app/auto-messages/:organization_id/home",
    name: "auto-messages-home",
    component: AutoMessageHome,
  },
  {
    path: "/app/events/:organization_id",
    name: "events",
    component: Events,
  },
  {
    path: "/app/events/:organization_id/abeyance",
    name: "shipping-events-held-in-abeyance",
    component: ShippingEventsHeldInAbeyance,
  },
  {
    path: "/app/auto-messages/:organization_id/:template_context/:template_subject_id",
    name: "auto-messages-template-settings",
    component: AutoMessageTemplateSettings,
  },
  {
    path: "/app/auto-messages-search/:organization_id/:template_context/:template_subject_id",
    name: "auto-messages-search-messages",
    component: AutoMessageSearchMessages,
  },
  {
    path: "/app/auto-messages-search/:organization_id",
    name: "auto-messages-search-all-messages",
    component: AutoMessageSearchAllMessages,
  },
  {
    path: "/app/auto-messages-search/:organization_id/:template_context/:template_subject_id",
    name: "auto-messages-manual-trigger",
    component: AutoMessageManualTrigger,
  },
  {
    path: "/app/branding/banner/:banner_id",
    name: "edit-banner-branding",
    component: EditBannerBranding,
  },
  {
    path: "/app/following/:employee_id",
    name: "employee-following",
    component: EmployeeFollowing,
  },
  {
    path: "/app/compliance/export-comm-log/:organization_id",
    name: "compliance-export-communications-log",
    component: ComplianceExportCommunicationLog,
  },
  {
    path: "/app/compliance/archives/:organization_id",
    name: "compliance-archives",
    component: ComplianceArchives,
  },
  {
    path: "/app/home/:endpoint/:conversation_id",
    name: "home-routed",
    component: Home,
  },
  {
    path: "/app/confirm-demo-booking",
    name: "confirm_demo_booking",
    component: PublicConfirmDemoBooking,
    meta: { isPublic: true }
  },
  {
    path: "/app/conversation-comment-request/:comment_request_id",
    name: "public-conversation-comment-request",
    component: PublicConversationComment,
    meta: { isPublic: true }
  },
  {
    path: "/app/sl/:front_end_link_id",
    name: "short_link_router",
    component: ShortLinkRouter,
    meta: { isPublic: true }
  },
  {
    path: "/app/shopify/install",
    name: "shopify_install",
    component: ShopifyInstall,
    meta: { isPublic: true }
  },
  {
    path: "/app/public/red-chirp-provide-payment-method/thank-you",
    name: "red-chirp-provide-payment-method-thank-you",
    component: PublicRedChirpProvidePaymentThankYou,
    meta: { isPublic: true }
  },
  {
    path: "/app/public/red-chirp-provide-payment-method/:organization_id",
    name: "red-chirp-provide-payment-method-start",
    component: PublicRedChirpProvidePaymentStart,
    meta: { isPublic: true }
  },
  {
    path: "/app/public/red-chirp-provide-wine-direct-credentials",
    name: "red-chirp-provide-wine-direct-credentials",
    component: PublicRedChirpProvideWineDirectCredentials,
    meta: { isPublic: true }
  },
  {
    path: "/app/public/red-chirp-provide-secret/:secret_type",
    name: "red-chirp-provide-secret",
    component: PublicRedChirpProvideSecret,
    meta: { isPublic: true }
  },
  {
    path: "/app/opt-in/default/:organization_id",
    name: "default-opt-in-form",
    component: DefaultOptInForm,
    meta: { isPublic: true }
  },
  {
    path: "/app/opt-in/legal/terms-and-conditions/:organization_id",
    name: "default-terms-and-conditions-addendum",
    component: TermsAndConditionsAddendum,
    meta: { isPublic: true }
  },
  {
    path: "/app/opt-in/legal/privacy-policy/:organization_id",
    name: "default-privacy-policy-addendum",
    component: PrivacyPolicyAddendum,
    meta: { isPublic: true }
  },
  {
    path: "/app/link-tree/wine-shipping/:auth",
    name: "link-tree-wine-shipping",
    component: PublicLinkTreeWineShipping,
    meta: { isPublic: true }
  },
  {
    path: "/app/guest-check-in/search/:organization_id",
    name: "search-forms-guest-check-in",
    component: SearchGuestCheckInForms,
  },
  {
    path: "/app/guest-check-in/template-selection/:organization_id",
    name: "guest-check-in-template-selection",
    component: GuestCheckInTemplateSelection,
  },
  {
    path: "/app/guest-check-in/edit/:organization_id/:guest_check_in_form_id",
    name: "guest-check-in-edit",
    component: GuestCheckInEdit,
  },
  {
    path: "/app/demos",
    name: "demo-selector",
    component: DemoSelector
  },
  {
    path: "/app/demos/order-confirmation/gateway",
    name: "order-confirmation-demo-gateway",
    component: OrderConfirmationDemoGateway,
  },
  {
    path: "/app/demos/order-confirmation/experience",
    name: "order-confirmation-demo-start",
    component: OrderConfirmationDemoStart,
    meta: { isPublic: true }
  },
  {
    path: "/app/demos/crm-account-confirmation/gateway",
    name: "crm-account-confirmation-demo-gateway",
    component: CRMAccountConfirmationDemoGateway,
  },
  {
    path: "/app/demos/crm-account-confirmation/experience",
    name: "crm-account-confirmation-demo-start",
    component: CRMAccountConfirmationDemoStart,
    meta: { isPublic: true }
  },
  {
    path: "/app/demos/guest-check-in/gateway",
    name: "search-forms-guest-check-in-demo-gateway",
    component: SearchGuestCheckInFormsDemoGateway,
  },
  {
    path: "/app/guest-check-in/:guest_check_in_form_id",
    name: "guest-check-in-public-app",
    component: () => import('@/views/public/guest-check-in/guest-check-in-widget-wrapper.vue'),
    meta: { isPublic: true }
  },
  {
    path: "/app/oc/:short_id",
    name: "order-confirmation-public-short-id",
    component: () => import('@/views/public/order-confirmation/order-confirmation-short-id-wrapper.vue'),
    meta: { isPublic: true }
  },
  {
    path: "/app/forms/:form_id",
    name: "fill-custom-form",
    component: CustomFormFillPage,
    meta: { isPublic: true }
  },
  {
    path: "/app/forms/search/:organization_id",
    name: "search-forms",
    component: SearchForms,
  },
  {
    path: "/app/forms/edit/:form_id",
    name: "edit-form",
    component: EditForm,
  },
  {
    path: "/app/opt-in/default/:organization_id/:banner_id",
    name: "default-opt-in-form-with-banner-id",
    component: DefaultOptInForm,
    meta: { isPublic: true }
  },
  {
    path: "/app/opt-in/toll-free/:organization_id",
    name: "toll-free-opt-in-form",
    component: TollFreeOptInForm,
    meta: { isPublic: true }
  },
  {
    path: "/app/opt-in/toll-free/:organization_id/:banner_id",
    name: "toll-free-opt-in-form-with-banner-id",
    component: TollFreeOptInForm,
    meta: { isPublic: true }
  },
  {
    path: '/app/contact-requests/:contact_request_id',
    name: 'contact-request',
    component: ContactRequest,
  },
  {
    path: '/app/contact-requests/open/:employee_id',
    name: 'search-open-contact-requests',
    component: SearchOpenContactRequests,
  },
  {
    path: '/app/contacts/fulltext-search/:organization_id',
    name: 'fulltext-search-contacts',
    component: FullTextContacts,
  },
  {
    path: '/app/contacts/savepoint/search/:organization_id',
    name: 'search-bulk-contact-changes',
    component: SearchBulkContactChanges,
  },
  {
    path: '/app/contacts/savepoint/search/:organization_id/:savepoint_id',
    name: 'search-bulk-contact-change-entries',
    component: SearchBulkContactChangeEntries,
  },
  {
    path: '/app/contacts/:contact_id',
    name: 'edit-contact',
    component: EditContact,
  },
  {
    path: '/app/payments/view/:payment_id',
    name: 'view-payment',
    component: ViewPayment,
  },
  {
    path: '/app/payments/search/:organization_id',
    name: 'search-payments',
    component: SearchPayments,
  },
  {
    path: '/app/integrations/adf/send/:integration_id/:conversation_id/:active_endpoint',
    name: 'integration-adf-send',
    component: AdfSend,
  },
  {
    path: '/app/integrations/adf/add-note/:integration_id/:conversation_id/:active_endpoint',
    name: 'integration-adf-add-note',
    component: AdfCopyNote,
  },
  {
    path: '/app/alerts/delivery-preferences/:employee_id',
    name: 'alert-delivery-preferences',
    component: AccountSettingsAlerts
  },
  {
    path: '/app/admin/search-alerts',
    name: 'admin-search-alerts',
    component: AdminAlerts,
  },
  {
    path: '/app/admin/sales-forecast',
    name: 'admin-sales-forecast',
    component: AdminSalesForecast,
  },
  {
    path: '/app/settings/custom-consent-agreements/:organization_id',
    name: 'settings-custom-consent-agreements',
    component: CustomConsentAgreements,
  },
  {
    path: '/app/admin/engagement/home',
    name: 'admin-engagement-home',
    component: AdminEngagementHome,
  },
  {
    path: '/app/admin/tn-tools',
    name: 'admin-tn-tools',
    component: AdminTNTools,
  },
  {
    path: '/app/admin/engagement/bulk-messages',
    name: 'admin-engagement-bulk-messages',
    component: AdminEngagementBulkMessages,
  },
  {
    path: '/app/admin/engagement/contact-request-alarm',
    name: 'admin-engagement-contact-request-alarm',
    component: AdminEngagementContactRequestAlarm,
  },
  {
    path: '/app/admin/tcr/events',
    name: 'admin-search-tcr-events',
    component: AdminTCREvents,
  },
  {
    path: '/app/admin/tcr/campaigns',
    name: 'admin-search-tcr-campaigns',
    component: AdminTCRCampaigns,
  },
  {
    path: '/app/admin/link-trees',
    name: 'admin-link-trees',
    component: AdminLinkTree,
  },
  {
    path: '/app/admin/secrets',
    name: 'admin-secrets',
    component: AdminSecrets,
  },
  {
    path: '/app/admin/search-invoices',
    name: 'admin-search-invoices',
    component: AdminSearchInvoices,
  },
  {
    path: '/app/admin/calendar',
    name: 'admin-calendar',
    component: AdminCalendar,
  },
  {
    path: '/app/admin/stock-images',
    name: 'admin-stock-images',
    component: AdminStockImages
  },
  {
    path: '/app/media-asset/edit-all/:organization_id',
    name: 'media-asset-edit-all',
    component: MediaAssetPageEditAll,
  },
  {
    path: '/app/media-asset/edit-all/:organization_id/:content_type',
    name: 'media-asset-edit-all-one-content-type',
    component: MediaAssetPageEditAll,
  },
  {
    path: '/app/media-asset/edit-all/:organization_id/:content_type/:asset_id',
    name: 'media-asset-edit-one-with-content-type',
    component: EditOneMediaAsset,
  },
  {
    path: '/app/media-asset/edit-all/:organization_id/:asset_id',
    name: 'media-asset-edit-one',
    component: EditOneMediaAsset,
  },
  {
    path: '/app/admin/calendly-events',
    name: 'admin-calendar-events',
    component: AdminCalendarEvents,
  },
  {
    path: '/app/admin/calendly-event-types',
    name: 'admin-calendly-event-types',
    component: AdminCalendlyEventTypes,
  },
  {
    path: "/app/sign-in",
    name: "sign-in",
    component: SignIn,
    meta: { isPublic: true }
  },
  {
    path: "/app/sign-in-sso",
    name: "sign-in-sso",
    component: SignInSSO,
    meta: { isPublic: true }
  },
  {
    path: "/app/reset-password",
    name: "reset-password",
    component: ResetPassword,
    meta: { isPublic: true }
  },
  {
    path: "/app/setup-account",
    name: "setup-account-reset-password",
    component: ResetPassword,
    meta: { isPublic: true }
  },
  {
    path: '/app/pay/:payment_id',
    name: 'make-payment',
    component: MakePayment,
    meta: { isPublic: true }
  },
  {
    path: '/app/pay/:vanity_url_portion/:payment_id',
    name: 'make-payment-with-vanity-portion',
    component: MakePayment,
    meta: { isPublic: true }
  },
  {
    path: '/app/t/demo',
    name: 'demo-tracking',
    component: DemoTracking,
    meta: { isPublic: true }
  },
  {
    path: "/app/start-reset-password",
    name: "start-reset-password",
    component: StartResetPassword,
    meta: { isPublic: true }
  },
  {
    path: "/app/test/test-axios",
    name: "test-axios",
    component: TestAxios,
    meta: { isPublic: true }
  },
  {
    path: "/app/test/test-tock-reservation",
    name: "test-tock-reservation",
    component: TestTockReservation,
  },
  {
    path: "/app/test/test-showdown",
    name: "test-showdown",
    component: TestShowdown,
  },
  {
    path: "/app/help",
    name: "help",
    component: Help,
  },
  {
    path: "/app/test/all-tests",
    name: "all-tests",
    component: AllTests
  },
  {
    path: "/app/analytics/:organization_id",
    name: "all-analytics",
    component: AllAnalytics
  },
  {
    path: "/app/analytics/web-chat/:organization_id",
    name: "analytics-web-chat",
    component: AnalyticsWebChat
  },
  {
    path: "/app/analytics/all-bulk-messages/:organization_id",
    name: "analytics-all-bulk-messages",
    component: AnalyticsAllBulkMessages
  },
  {
    path: "/app/analytics/all-club-customization/:organization_id",
    name: "analytics-all-club-customization",
    component: AnalyticsAllClubCustomization
  },
  {
    path: "/app/analytics/all-bulk-messages/:organization_id/:analytics_group_id",
    name: "analytics-one-bulk-message-analytics-group",
    component: AnalyticsOneBulkMessageAnalyticsGroup
  },
  {
    path: "/app/analytics/opt-in/:organization_id",
    name: "analytics-opt-in",
    component: AnalyticsOptIn
  },
  {
    path: "/app/test/test-messenger-layout",
    name: "test-messenger-layout",
    component: TestMessengerLayout
  },
  {
    path: "/app/test/test-revoke-auth",
    name: "test-revoke-auth",
    component: TestRevokeAuth
  },
  {
    path: "/app/test/test-table",
    name: "test-table",
    component: TestTable,
  },
  {
    path: "/app/test/test-signature",
    name: "test-signature",
    component: TestSignature,
  },
  {
    path: "/app/test/test-input",
    name: "test-input",
    component: TestInput,
  },
  {
    path: "/app/settings/organization/:organization_id/fonts",
    name: "settings-organization-fonts",
    component: SettingsOrganizationFonts,
  },
  {
    path: "/app/lightbox/search-settings/:organization_id",
    name: "lightbox-search-settings",
    component: LightboxSearchSettings,
  },
  {
    path: "/app/lightbox/settings/:organization_id/:lightbox_id",
    name: "lightbox-edit",
    component: LightboxEdit,
  },
  {
    path: "/app/lightbox/template-selection/:organization_id",
    name: "lightbox-template-selection",
    component: LightboxTemplateSelection,
  },
  {
    path: "/app/lightbox/submissions/:organization_id/",
    name: "lightbox-submissions",
    component: LightboxSubmissions,
  },
  {
    path: "/app/guest-check-in/submissions/:organization_id",
    name: "guest-check-in-submissions",
    component: GuestCheckInSubmissions,
  },
  {
    path: "/app/guest-check-in/analytics/:organization_id",
    name: "guest-check-in-analytics",
    component: GuestCheckInAnalytics,
  },
    {
    path: "/app/order-confirmation/search/:organization_id",
    name: "search-forms-order-confirmation",
    component: SearchOrderConfirmationForms,
  },
  {
    path: "/app/order-confirmation/template-selection/:organization_id",
    name: "order-confirmation-template-selection",
    component: OrderConfirmationTemplateSelection,
  },
  {
    path: "/app/order-confirmation/edit/:organization_id/:order_confirmation_settings_id",
    name: "order-confirmation-edit",
    component: OrderConfirmationEdit,
  },
  {
    path: "/app/order-confirmation/submissions/:organization_id",
    name: "order-confirmation-submissions",
    component: OrderConfirmationSubmissions,
  },
  {
    path: "/app/order-confirmation/analytics/:organization_id",
    name: "order-confirmation-analytics",
    component: OrderConfirmationAnalytics,
  },
  {
    path: "/app/lightbox/urls/:organization_id",
    name: "lightbox-urls",
    component: LightboxURLS,
  },
  {
    path: "/app/test/test-timeline",
    name: "test-timeline",
    component: TestTimeline,
  },
  {
    path: "/app/test/test-attachments",
    name: "test-attachments",
    component: TestAttachments
  },
  {
    path: '/app/test/test-environment',
    name: 'test-environment',
    component: TestGetRestAPIEnvironment,
  },
  {
    path: '/app/test/test-global-controls',
    name: 'test-global-controls',
    component: TestGlobalControls,
  },
  {
    path: "/app/admin/all-admin",
    name: "all-admin",
    component: AllAdmin
  },
  {
    path: "/app/admin/admin-red-chirp-staff-roles",
    name: "admin-red-chirp-staff-roles",
    component: RedChirpStaffRoles
  },
  {
    path: '/app/admin/shortened-link-domains',
    name: 'admin-shortened-link-domains',
    component: AdminShortenedLinkDomains,
  },
  {
    path: "/app/admin/red-chirp-sso-settings",
    name: "admin-red-chirp-sso-settings",
    component: () => import('../views/admin/admin-red-chirp-sso-settings.vue')
  },
  {
    path: "/app/admin/admin-redchirp-stripe-search",
    name: "admin-redchirp-stripe-search",
    component: AdminRedChirpStripeSearch
  },
  {
    path: "/app/admin/setup-demo",
    name: "admin-setup-demo",
    component: AdminSetupDemo
  },
  {
    path: "/app/admin/admin-processors",
    name: "admin-processors",
    component: AdminProcessors
  },
  {
    path: "/app/admin/admin-knobs",
    name: "admin-knobs",
    component: AdminKnobs
  },
  {
    path: "/app/admin/admin-intuit",
    name: "admin-intuit",
    component: AdminIntuit
  },
  {
    path: "/app/admin/admin-freshdesk",
    name: "admin-freshdesk",
    component: () => import('../views/admin/admin-freshdesk.vue')
  },
  {
    path: "/app/admin/admin-billing-search-organizations",
    name: "admin-billing-search-organizations",
    component: AdminBillingSearchOrganizations
  },
  {
    path: "/app/admin/mrr",
    name: "admin-mrr",
    component: RedChirpMRR
  },
  {
    path: "/app/admin/nrr",
    name: "admin-nrr",
    component: AdminNRR
  },
  {
    path: "/app/rest-refernce/search",
    name: "admin-search-rest-reference",
    component: AdminSearchRestAPIReference
  },
  {
    path: "/app/admin/billing/one-organization/:organization_id",
    name: "admin-billing-one-organization",
    component: AdminBillingOneOrganizations,
  },
  {
    path: "/app/admin/admin-built-in-rate-cards",
    name: "admin-built-in-rate-cards",
    component: AdminBuiltInRateCards
  },

  {
    path: "/app/admin/organization-setup-wizard/:organization_id",
    name: "admin-organization-setup-wizard",
    component: AdminOrganizationSetupWizard
  },
  {
    path: "/app/admin/create-organization/:organization_id",
    name: "admin-create-organization",
    component: CreateOrganization
  },
  {
    path: "/app/admin/admin-search-redchirp-numbers",
    name: "admin-search-redchirp-numbers",
    component: AdminSearchRedChirpNumbers
  },
  {
    path: "/app/admin/admin-search-organizations",
    name: "admin-search-organizations",
    component: AdminSearchOrganizations
  },
  {
    path: "/app/admin/admin-search-employees",
    name: "admin-search-employees",
    component: AdminSearchEmployees
  },
  {
    path: "/app/admin/reports",
    name: "admin-reports",
    component: AdminReports
  },
  {
    path: "/app/admin/reports/start",
    name: "admin-start-report",
    component: AdminStartReport
  },
  {
    path: "/app/admin/admin-multi-org-employee/:employee_id",
    name: "admin-multi-org-employee",
    component: AdminMultiOrgEmployee
  },
  {
    path: "/app/admin/admin-password-reset-links",
    name: "admin-password-reset-links",
    component: AdminPasswordResetLinks
  },
  {
    path: "/app/admin/admin-separate-customers-prospects",
    name: "admin-separate-customers-prospects",
    component: AdminSeparateCustomersProspects
  },
  {
    path: "/app/integrations/big-commerce/pair-organization/:store_hash",
    name: "big-commerce-pair-organization",
    component: BigCommercePairOrganization
  },
  {
    path: "/app/integrations/big-commerce/pair-organization-complete",
    name: "big-commerce-pair-organization-complete",
    component: BigCommercePairComplete
  },
  {
    path: "/app/error/no-employee-endpoints",
    name: "error-no-employee-endpoints",
    component: ErrorNoEmployeeEndpoints
  },
  {
    path: "/app/error/conversation-not-found/:conversation_id",
    name: "error-conversation-not-found",
    component: ErrorConversationNotFound
  },
  {
    path: "/app/settings/organization/:organization_id",
    name: "settings-organization",
    component: SettingsOrganization,
  },
  {
    path: "/app/settings/organization/api-keys/:organization_id",
    name: "settings-organization-api-keys",
    component: SettingsOrganizationAPIKeys,
  },
  {
    path: "/app/settings/organization/api-call-log/:organization_id",
    name: "settings-organization-api-call-log",
    component: () => import('../views/settings/organizations/settings-organization-api-call-log.vue'),
  },
  {
    path: "/app/settings/organization/account-change-log/:organization_id",
    name: "account-change-log",
    component: AccountChangeLog
  },
  {
    path: "/app/settings/organization/account-access-log/:organization_id",
    name: "account-access-log",
    component: AccountAccessLog
  },
  {
    path: "/app/settings/organization/rc-tags/:organization_id",
    name: "settings-organization-tags",
    component: SettingsOrganizationTags,
  },
  {
    path: "/app/settings/organization/order-attribution/:organization_id",
    name: "settings-organization-order-attribution",
    component: SettingsOrganizationOrderAttribution,
  },
  {
    path: "/app/settings/organization/order-attribution/:organization_id/:order_attribution_settings_id",
    name: "settings-organization-order-attribution-one",
    component: SettingsOrganizationOrderAttributionOne,
  },
  {
    path: "/app/settings/organization/rc-tags/:organization_id/:rc_tag_id",
    name: "settings-organization-tags-edit-one",
    component: SettingEditOneTag,
  },
  {
    path: "/app/settings/organization/branded-link-shortener/:organization_id",
    name: "settings-organization-branded-link-shortener",
    component: SettingsOrganizationBrandedLinkShortener,
  },
  {
    path: "/app/numbers/endpoint-unavailable-auto-response/:organization_id/:endpoint",
    name: "settings-organization-endpoint-unavailable-auto-response",
    component: SettingOrganizationEndpointUnavailableAutoResponse,
  },
  {
    path: "/app/settings/organization/schedule/:organization_id",
    name: "settings-organization-schedule",
    component: SettingsOrganizationSchedule,
  },
  {
    path: "/app/settings/organization/spam-numbers/:organization_id",
    name: "settings-organization-spam-numbers",
    component: SettingsOrganizationSpamNumbers,
  },
  {
    path: '/app/settings/organization-test-widget/:organization_id',
    name: "settings-organization-test-widget",
    component: SettingsOrganizationTestWidget,
  },
  {
    path: "/app/settings/organization/inbox/:organization_id/:inbox_id",
    name: "edit-inbox",
    component: EditInbox,
  },
  {
    path: "/app/settings/organization/webchat-widget/:organization_id",
    name: "settings-organization-widget",
    component: SettingsOrganizationWidget,
  },
  {
    path: "/app/settings/organization/data-cleaning-rules/:organization_id",
    name: "settings-organization-data-cleaning-rules",
    component: SettingsOrganizationDataCleaning,
  },
  {
    path: "/app/settings/organization/sso-settings/:organization_id",
    name: "settings-organization-sso-settings",
    component: SettingsOrganizationSSOPage,
  },
  {
    path: "/app/settings/organization/links/:organization_id",
    name: "search-links",
    component: SearchLinks,
  },
  {
    path: '/app/settings/organization/inbox/:organization_id',
    name: 'edit-inboxes',
    component: EditInboxes
  },
  {
    path: "/app/settings/account/:employee_id",
    name: "settings-account",
    component: SettingsAccount,
  },
  {
    path: '/app/settings/account/oauth-integrations/:employee_id',
    name: 'settings-account-search-oauth-integrations',
    component: SearchOAuthIntegrations
  },
  {
    path: '/app/contact-requests/search-inbox-contact-requests/:organization_id/:inbox_id',
    name: 'search-inbox-contact-requests',
    component: SearchInboxContactRequests,
  },
  {
    path: '/app/contact-requests/search-inbox-contact-requests/:organization_id',
    name: 'search-inbox-contact-requests-without-start-inbox',
    component: SearchInboxContactRequests,
  },
  {
    path: '/app/consent/search/:organization_id',
    name: 'search-consent-register',
    component: SearchBulkOptInOut,
  },
  {
    path: '/app/consent/imports/search/:organization_id',
    name: 'search-consent-imports',
    component: SearchConsentImports,
  },
  {
    path: '/app/consent/imports/upload/:organization_id/:import_id?',
    name: 'consent-import-upload',
    component: ConsentImportUpload,
  },


  {
    path: '/app/contacts/imports/search/:organization_id',
    name: 'contact-import-search',
    component: SearchContactImports,
  },
  {
    path: '/app/contacts/imports/upload/:organization_id/:import_id?',
    name: 'contact-import-upload',
    component: ContactImportPage,
  },

  // Contact List Import Routes
  {
    path: '/app/contact-lists/imports/search/:organization_id',
    name: 'search-contact-list-imports',
    component: SearchContactListImports,
  },
  {
    path: '/app/contact-lists/imports/upload/:organization_id/:import_id?',
    name: 'contact-list-import-upload',
    component: ContactListImportUpload,
  },
  // Bulk Message Recipient Import Routes
  {
    path: '/app/bulk/messages/imports/search/:organization_id',
    name: 'search-bulk-message-recipient-imports',
    component: SearchBulkMessageRecipientImports,
  },
  {
    path: '/app/bulk/messages/imports/upload/:organization_id/:import_id?',
    name: 'bulk-message-recipients-import-upload',
    component: BulkMessageRecipientsImportUpload,
  },
  {
    path: '/app/bulk/search-bulk-messages/:organization_id',
    name: 'search-bulk-messages',
    component: SearchBulkMessages,
  },
  {
    path: '/app/bulk/messages/:organization_id/:bulk_message_id/recipients-remove-recent-orders',
    name: 'bulk-recipient-remove-recent-order',
    component: BulkRecipientRemoveRecentOrder,
  },
  {
    path: '/app/bulk/messages/:organization_id/:bulk_message_id/sentiment-forecast',
    name: 'bulk-message-sentiment-forecast',
    component: BulkMessageSentimentForecast,
  },
  {
    path: '/app/model/r1/edit/:organization_id/:bulk_message_id',
    name: 'model-r1-edit',
    component: ModelR1Edit
  },
  {
    path: '/app/model/r1/inference/detail/:organization_id/:bulk_message_id/:bulk_message_recipient_id',
    name: 'model-r1-inference-detail',
    component: BulkMessageRecipientInferenceDetail,
  },
  {
    path: '/app/bulk/admin/templates/search/:organization_id',
    name: 'admin-bulk-message-templates',
    component: AdminBulkMessageTemplates,
  },
  {
    path: '/app/bulk/templates/search/styled/:organization_id',
    name: 'bulk-message-template-create-page',
    component: BulkMessageTemplateCreatePage,
  },
  {
    path: '/app/consent/details/:organization_id/:endpoint',
    name: 'view-consent-details',
    component: ViewBulkOptOutDetails,
  },
  {
    path: '/app/bulk/messages/:organization_id/:bulk_message_id',
    name: 'view-bulk-message',
    component: ViewBulkMessage,
  },
  {
    // redirect old bulk message status URL to new view URL above
    path: '/app/bulk/messages/:organization_id/status/:bulk_message_id',
    redirect: to => ({
      name: 'view-bulk-message',
      params: {
        organization_id: to.params.organization_id,
        bulk_message_id: to.params.bulk_message_id
      }
    })
  },
  {
    path: '/app/bulk/recipients/import/:organization_id/:bulk_message_id/:import_id',
    name: 'bulk-recipient-import',
    component: BulkRecipientImport,
  },
  {
    path: '/app/saved-messages/search/:organization_id',
    name: 'search-saved-messages',
    component: SearchSavedMessages,
  },
  {
    path: '/app/bulk/recipients/preview/:organization_id/:bulk_message_id/:import_id',
    name: 'bulk-recipient-preview',
    component: BulkRecipientPreview,
  },
  {
    path: '/app/contact-requests/detail/:contact_request_id',
    name: 'contact-request-detail',
    component: ViewInboxContactRequestProfile,
  },
  {
    path: '/app/admin/uptime',
    name: 'admin-uptime',
    component: AdminUptime,
  },
  {
    path: '/app/admin/sales-after-booking-demo-surveys',
    name: 'admin-sales-after-booking-demo-surveys',
    component: SalesAfterDemoBookingSurveys,
  },
  {
    path: '/app/admin/multidemo',
    name: 'admin-multidemo',
    component: AdminMultiDemo,
  },
  {
    path: '/app/admin/process-history',
    name: 'admin-process-history',
    component: AdminProcessHistory,
  },
  {
    path: '/app/admin/search-typeform',
    name: 'admin-search-typeform',
    component: AdminTypeform,
  },
  {
    path: '/app/admin/typeform-settings/:form_id',
    name: 'admin-settings-typeform',
    component: AdminTypeformSettings,
  },
  {
    path: '/app/contact-requests/form-connect/:organization_id/:inbox_id',
    name: 'form-connect',
    component: FormConnect,
  },
  {
    path: '/app/admin/widget-analytics',
    name: 'admin-widget-analytics',
    component: WidgetAnalytics,
  },
  // Public URLs
  {
    path: '/app/public/widget-pixel-code-instructions',
    name: 'public-widget-code',
    component: PublicWidgetCode,
    meta: { isPublic: true }
  },
  {
    path: '/app/public/restricted-messaging-times',
    name: 'public-restricted-messaging-times',
    component: PublicRestrictedMessagingTimes,
    meta: { isPublic: true }
  },
  {
    path: "/app/ios/to-instructions",
    name: "ios-to-instructions",
    component: ios_to_instructions,
    meta: { isPublic: true }
  },
  {
    path: "/app/ios/launcher",
    name: "ios-launcher",
    component: ios_launcher,
    meta: { isPublic: true }
  },
  {
    path: '/app/public/widget-gtm-instructions',
    name: 'public-widget-gtm',
    component: PublicWidgetGTM,
    meta: { isPublic: true }
  },
  {
    path: '/app/public/legal',
    name: 'public-legal-home',
    component: PublicLegalCenter,
    meta: { isPublic: true }
  },
  {
    path: '/app/public/legal/updated-agreements-2026-announcement',
    name: 'public-updated-agreements-2026-announcement',
    component: PulbicUpdatedAgreements2026Announcement,
    meta: { isPublic: true }
  },
  {
    path: '/app/public/magic-link/expired/:organization_id',
    name: 'public-magic-link-expired',
    component: PublicMagicLinkExpire,
    meta: { isPublic: true }
  },
  {
    path: '/app/sanderson/barrett-jackson',
    name: 'public-sanderson-barrett-jackson',
    component: PublicSandersonBarrettJackson,
    meta: { isPublic: true }
  },
  {
    path: '/app/platypus/your-tour',
    name: 'public-platypus-your-tour',
    component: PublicPlatypusTour,
    meta: { isPublic: true }
  },
  {
    path: '/app/tasting/your-tasting',
    name: 'public-wine-tasting',
    component: PublicYourTasting,
    meta: { isPublic: true }
  },
  {
    path: '/app/platypus/your-tour/:one_year',
    name: 'public-platypus-your-tour-one-year-later',
    component: PublicPlatypusTour,
    meta: { isPublic: true }
  },
  {
    path: '/app/inbox-email-log/:organization_id/:inbox_id',
    name: 'inbox-email-log',
    component: InboxEmailLog
  },
  {
    path: '/app/integrations/crm/:content_type/home/:organization_id',
    name: 'crm-home',
    component: CRMHome
  },
  {
    path: '/app/integrations/crm/:content_type/search-contacts/:organization_id',
    name: 'crm-customers',
    component: CRMContacts
  },
  {
    path: '/app/integrations/crm/:content_type/search-shipments/:organization_id',
    name: 'crm-shipments',
    component: CRMShipments
  },
  {
    path: '/app/integrations/crm/:content_type/search-tag-meta-data/:organization_id',
    name: 'crm-tag-meta-data',
    component: CRMTagMetaData
  },
  {
    path: '/app/integrations/crm/:content_type/search-club-meta-data/:organization_id',
    name: 'crm-club-meta-data',
    component: CRMClubMetaData
  },
  {
    path: '/app/integrations/crm/:integration_type/search-group-meta-data/:organization_id',
    name: 'crm-group-meta-data',
    component: CRMGroupMetaData
  },
  {
    path: '/app/integrations/crm/:content_type/search-tag-change-log/:organization_id',
    name: 'crm-tag-change-log',
    component: CRMTagChangeLog
  },

  {
    path: '/app/integrations/crm/:content_type/search-reservations/:organization_id',
    name: 'crm-reservations',
    component: CRMReservations
  },
  {
    path: '/app/integrations/crm/:content_type/reservation-time-zones/:organization_id',
    name: 'crm-reservation-location-time-zones',
    component: CRMReservationTimeZones
  },
  {
    path: '/app/integrations/crm/:content_type/search-orders/:organization_id',
    name: 'crm-orders',
    component: CRMOrders
  },
  {
    path: '/app/integrations/crm/:content_type/search-orders-by-phone/:organization_id',
    name: 'crm-orders-by-phone',
    component: CRMOrdersByPhone
  },
  {
    path: '/app/integrations/crm/:organization_id/:content_type/:customer_id',
    name: 'integration-crm-search-conversations',
    component: IntegrationCRMSearchConversations
  },
  {
    path: '/app/integrations/commerce7/start-conversation/:organization_id/:customer_id',
    name: 'integration-commerce7-start-conversation',
    component: IntegrationCommerce7StartConversation
  },
  {
    path: '/app/widget/edit-settings/:settings_id',
    name: 'edit-widget-settings',
    component: EditWidgetSettings
  },
  {
    path: "/app/integrations/:settings_id/sync-history",
    name: "integration-sync-history",
    component: IntegrationSyncHistory,
  },
  {
    path: "/app/integrations/:settings_id/sync-history/:sync_batch_id",
    name: "integration-sync-history-one-batch",
    component: IntegrationSyncHistoryOneBatch,
  },
  {
    path: '/app/organization/rate-card/:organization_id',
    name: 'edit-organization-rate-card',
    component: OrganizationSettingsRateCard
  },
  {
    path: '/app/organization/billing-settings/:organization_id',
    name: 'organization-redchirp-billing-settings',
    component: OrganizationSettingsRedChirpBilling,
  },
  {
    path: '/app/keyword-auto-response/settings/:organization_id',
    name: 'settings-organization-keyword-auto-responses',
    component: SettingsOrganizationKeywordAutoresponses
  },
  {
    path: '/app/keyword-auto-response/settings/:organization_id/:keyword',
    name: 'edit-keyword-auto-response',
    component: EditKeywordAutoResponse
  },
  {
    path: '/app/keyword-auto-response/reporting/:organization_id/:keyword',
    name: 'reporting-keyword-auto-response-w-initial-keyword',
    component: ReportingKeywordAutoResponse
  },
  {
    path: '/app/keyword-auto-response/reporting/:organization_id',
    name: 'reporting-keyword-auto-response',
    component: ReportingKeywordAutoResponse
  },
  {
    path: '/app/ctia-keyword-auto-response/settings/:organization_id',
    name: 'settings-organization-ctia-keyword-auto-responses',
    component: SettingsOrganizationCTIAKeywordAutoresponses
  },
  {
    path: '/app/admin/incidents/search',
    name: 'admin-search-incidents',
    component: AdminSearchIncidents
  },
  {
    path: '/app/admin/incidents/edit/:incident_id',
    name: 'incident-edit',
    component: EditIncident
  },
  {
    path: '/app/endpoint-validation/search-details/:organization_id',
    name: 'search-endpoint-validation-details',
    component: SearchEndpointValidationDetails
  },
  {
    path: '/app/settings/organization/introduction/:organization_id',
    name: 'settings-organization-introductions',
    component: SettingsOrganizationIntroductions
  },
  {
    path: '/app/red-chirp-crm/view-organization/:organization_id',
    name: 'rc-crm-view-organization',
    component: RedChirpCRMViewOrganization
  },
  {
    path: '/app/developer/search-my-apps/:organization_id',
    name: 'developer-search-my-apps',
    component: DeveloperSearchMyApps
  },
  {
    path: '/app/developer/edit-app/:organization_id/:app_id/:version',
    name: 'developer-edit-app',
    component: DeveloperEditApp
  },
  {
    path: '/app/developer/app-credentials/:organization_id/:app_id',
    name: 'developer-app-credentials',
    component: DeveloperAppCredentials
  },
  {
    path: '/app/developer/search-installs/:organization_id/:app_id',
    name: 'developer-search-app-installs',
    component: DeveloperSearchMyAppInstalls,
  },
  {
    path: '/app/search/:organization_id',
    name: 'app-search',
    component: AppSearch
  },
  {
    path: '/app/:organization_id/:app_id',
    name: 'app-details',
    component: AppDetails,
  },
  {
    path: '/app/integrations/outshinery/home',
    name: 'portal-outshinery-home',
    component: PortalOutshineryHome
  },
  {
    path: '/app/accessibility',
    name: 'accessibility',
    component: Accessibility
  },

  {
    path: "/*",
    redirect: "/app/home"
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

// suppress programmatic navigation errors that are expected (like when guards block/redirect navigation)
const original_push = router.push;
router.push = function push(location) {
  return original_push.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('navigation guard')) {
      throw err;
    }
  });
};

router.beforeEach((to, from, next) =>
{
  // check if a new frontend has been deployed and prompt the user to reload if so
  // the timer check ensures that this is only done at most once every n minutes
  if (VersionService.getIsInitialized()) {
    const versioning_timer = VersionService.getVersioningTimer();
    if (versioning_timer) {
      versioning_timer.runTimersCheck();
    }
  }

  if ( router.dialog_guard != null )
  {
    router.dialog_guard(to,from,next);
    return;
  }
  else
  {
    next();
  }

  return;
});

router.afterEach((to, from) =>
{
  window.gtag('set', 'page_path', to.path);
  window.gtag('send', 'page_view');

  return;
});

export default router;


